import React, { FC } from 'react'
import { Icon, IconProps } from '@chakra-ui/react'

const Minus: FC<IconProps> = (props) => {
  return (
    <Icon
      stroke="currentColor"
      viewBox="0 0 14 2"
      // ChakraUIs type definitions clash apparently.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...(props as any)}>
      <path d="M0 1H14" strokeMiterlimit="10" strokeWidth="2" />
    </Icon>
  )
}

// eslint-disable-next-line functional/immutable-data
Minus.displayName = 'Minus'

export { Minus }
